(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/account-selector/assets/javascripts/account-selector-modal.js') >= 0) return;  svs.modules.push('/components/marketplace/account-selector/assets/javascripts/account-selector-modal.js');

'use strict';

const {
  useState
} = React;
const {
  Modal
} = svs.components.react_modal;
const {
  AccountListItem
} = svs.components.marketplace.accountSelector;
const {
  products: prodUtils
} = svs.utils;
const {
  ReactIcon
} = svs.ui;
const AccountSelectorModal = _ref => {
  let {
    data,
    defaultSelected,
    infoText,
    onDone,
    productId,
    userAccountBalance
  } = _ref;
  const [selectedId, setSelectedId] = useState(defaultSelected);
  const handleSelect = id => setSelectedId(id);
  const handleDone = () => {
    onDone(selectedId);
  };
  const renderListItems = () => data.map((group, key) => {
    if (group.error) {
      return React.createElement("p", {
        className: "error-text",
        key: group.gameId + group.groupId + key || key
      }, group.error);
    }
    return React.createElement(AccountListItem, {
      activatedDrawId: group.activatedDrawId,
      balance: group.balance.toString(),
      groupId: group.groupId,
      groupName: group.name,
      key: group.gameId + group.groupId + key || key,
      onSelect: handleSelect,
      selectedAcc: selectedId,
      sharePrice: group.sharePrice
    });
  });
  return React.createElement(Modal, {
    buttonClassName: "inverted",
    headerClass: "".concat(prodUtils.getProdName(productId).toLowerCase(), "-modal-header"),
    leftButtonText: "Avsluta",
    onRightButtonClick: handleDone,
    rightButton: true,
    rightButtonText: "Klar",
    title: "Byt saldo"
  }, infoText && React.createElement("div", {
    className: "informational-message"
  }, React.createElement(ReactIcon, {
    color: "fc-black",
    icon: "info"
  }), React.createElement("span", null, infoText)), React.createElement("ul", {
    className: "marketplace-account-list",
    "data-testid": "qa-accountlist"
  }, React.createElement(AccountListItem, {
    activatedDrawId: "user",
    balance: userAccountBalance ? userAccountBalance.toString() : '0',
    groupId: "user",
    groupName: "Mitt spelkonto",
    onSelect: handleSelect,
    selectedAcc: selectedId
  }), renderListItems()));
};
setGlobal('svs.components.marketplace.accountSelector.AccountSelectorModal', AccountSelectorModal);

 })(window);